import React from "react";
import LiveModel3DPreview from "./LiveModel3DPreview";

/**
 * InlineModel3DEmbed — wraps LiveModel3DPreview for the FE RichContentViewer.
 * Renders an interactive 3D scene inline; the overlay button calls
 * `onOpenFullscreen(mediaId)` to navigate to a dedicated fullscreen route.
 */
const InlineModel3DEmbed = ({ media, mediaId, mediaResolver, onOpenFullscreen }) => (
  <LiveModel3DPreview
    media={media}
    mediaId={mediaId}
    mediaResolver={mediaResolver}
    onOpenFullscreen={onOpenFullscreen}
    height={400}
  />
);

export default InlineModel3DEmbed;
